import { useContext, useEffect, useState } from 'react';
import { SubscriptionPlansContext } from '../context/SubscriptionPlansContext';
import { Plans } from '../pages/constants';

const useSubscriptionPlanPrices = () => {
  const { subscriptionPlans } = useContext(SubscriptionPlansContext);
  const [seasonalPrice, setSeasonalPrice] = useState(null);
  const [annualPrice, setAnnualPrice] = useState(null);

  useEffect(() => {
    if (subscriptionPlans) {
      setSeasonalPrice(subscriptionPlans[Plans.SEASONAL]?.price?.amount);
      setAnnualPrice(subscriptionPlans[Plans.ANNUAL]?.price?.amount);
    }
  }, [subscriptionPlans]);

  return { seasonalPrice, annualPrice };
};

export default useSubscriptionPlanPrices;
